import de from './de-DE';
import en from './en-US';
import es from './es-ES';
import fr from './fr-FR';
import ja from './ja-JP';
import ko from './ko-KR';
import pt from './pt-PT';
import ru from './ru-RU';
import th from './th-TH';
import tr from './tr-TR';
import vi from './vi-VN';
import zh_CN from './zh-CN';
import zh_TW from './zh-TW';
import itIt from './it-IT';
import pl from './pl-PL';
import ar from './ar-SA';
import id from './id-ID';

// 黑五活动语言包，已在大麦语言包里面配好
import activity_de from './activity/de-DE';
import activity_en from './activity/en-US';
import activity_es from './activity/es-ES';
import activity_fr from './activity/fr-FR';
import activity_ja from './activity/ja-JP';
import activity_ko from './activity/ko-KR';
import activity_pt from './activity/pt-PT';
import activity_ru from './activity/ru-RU';
import activity_th from './activity/th-TH';
import activity_tr from './activity/tr-TR';
import activity_vi from './activity/vi-VN';
import activity_zh_CN from './activity/zh-CN';
import activity_zh_TW from './activity/zh-TW';
import activity_itIt from './activity/it-IT';
import activity_pl from './activity/pl-PL';
import activity_ar from './activity/ar-SA';
import activity_id from './activity/id-ID';

// v3支付页语言包
// 智轩：整理独立语言包便于管理
import v3_de from './v3/de-DE';
import v3_en from './v3/en-US';
import v3_es from './v3/es-ES';
import v3_fr from './v3/fr-FR';
import v3_ja from './v3/ja-JP';
import v3_ko from './v3/ko-KR';
import v3_pt from './v3/pt-PT';
import v3_ru from './v3/ru-RU';
import v3_th from './v3/th-TH';
import v3_tr from './v3/tr-TR';
import v3_vi from './v3/vi-VN';
import v3_zh_CN from './v3/zh-CN';
import v3_zh_TW from './v3/zh-TW';
import v3_itIt from './v3/it-IT';
import v3_pl from './v3/pl-PL';
import v3_ar from './v3/ar-SA';
import v3_id from './v3/id-ID';

// 发票申请页语言包
// 与其他的项目比较独立，所以单独放在这里
import invoice_de from './invoiceApplication/de-DE';
import invoice_en from './invoiceApplication/en-US';
import invoice_fr from './invoiceApplication/fr-FR';
import invoice_ja from './invoiceApplication/ja-JP';
import invoice_ko from './invoiceApplication/ko-KR';
import invoice_ru from './invoiceApplication/ru-RU';
import invoice_th from './invoiceApplication/th-TH';
import invoice_vi from './invoiceApplication/vi-VN';
import invoice_zh_CN from './invoiceApplication/zh-CN';
import invoice_zh_TW from './invoiceApplication/zh-TW';

// 美国未成年合规
import creditCardVerification_en_US from './creditCardVerification/en-US';
import creditCardVerification_zh_CN from './creditCardVerification/zh-CN';
import creditCardVerification_ja_JP from './creditCardVerification/ja-JP';
import creditCardVerification_ko_KR from './creditCardVerification/ko-KR';
import creditCardVerification_fr_FR from './creditCardVerification/fr-FR';
import creditCardVerification_de_DE from './creditCardVerification/de-DE';
import creditCardVerification_es_ES from './creditCardVerification/es-ES';
import creditCardVerification_ru_RU from './creditCardVerification/ru-RU';
import creditCardVerification_pt_PT from './creditCardVerification/pt-PT';
import creditCardVerification_it_IT from './creditCardVerification/it-IT';
import creditCardVerification_th_TH from './creditCardVerification/th-TH';
import creditCardVerification_tr_TR from './creditCardVerification/tr-TR';
import creditCardVerification_vi_VN from './creditCardVerification/vi-VN';
import creditCardVerification_id_ID from './creditCardVerification/id-ID';
import creditCardVerification_pl_PL from './creditCardVerification/pl-PL';
import creditCardVerification_ar_SA from './creditCardVerification/ar-SA';
import creditCardVerification_zh_TW from './creditCardVerification/zh-TW';

import { getHrefParam } from '../ultile';
import globalConfig from '../../utiles/globalConfig';
const RTL_LANG_LIST = ['ar-SA'];
const MAIN_HOSt = globalConfig.getMainHost();
let HOST = MAIN_HOSt.replace('.com', '');
if (HOST.length > 0) {
  if (btoa(HOST) === 'YmxhbmNvem9uZQ==') {
    HOST = HOST.replace(/zone$/, '');
  }
  let first = HOST[0];
  HOST = HOST.replace(first, first.toUpperCase());
}

// 黑五活动使用, 语言包合并(包含长期使用的语言包)
let LANG_MAP = {
  'en-US': Object.assign(
    {},
    en,
    activity_en,
    v3_en,
    invoice_en,
    creditCardVerification_en_US
  ),
  'es-ES': Object.assign(
    {},
    es,
    activity_es,
    v3_es,
    creditCardVerification_es_ES
  ),
  'tr-TR': Object.assign(
    {},
    tr,
    activity_tr,
    v3_tr,
    creditCardVerification_tr_TR
  ),
  'zh-CN': Object.assign(
    {},
    zh_CN,
    activity_zh_CN,
    v3_zh_CN,
    invoice_zh_CN,
    creditCardVerification_zh_CN
  ),
  'zh-TW': Object.assign(
    {},
    zh_TW,
    activity_zh_TW,
    v3_zh_TW,
    invoice_zh_TW,
    creditCardVerification_zh_TW
  ),
  'fr-FR': Object.assign(
    {},
    fr,
    activity_fr,
    v3_fr,
    invoice_fr,
    creditCardVerification_fr_FR
  ),
  'pt-PT': Object.assign(
    {},
    pt,
    activity_pt,
    v3_pt,
    creditCardVerification_pt_PT
  ),
  'vi-VN': Object.assign(
    {},
    vi,
    activity_vi,
    v3_vi,
    invoice_vi,
    creditCardVerification_vi_VN
  ),
  'th-TH': Object.assign(
    {},
    th,
    activity_th,
    v3_th,
    invoice_th,
    creditCardVerification_th_TH
  ),
  'ja-JP': Object.assign(
    {},
    ja,
    activity_ja,
    v3_ja,
    invoice_ja,
    creditCardVerification_ja_JP
  ),
  'ko-KR': Object.assign(
    {},
    ko,
    activity_ko,
    v3_ko,
    invoice_ko,
    creditCardVerification_ko_KR
  ),
  'ru-RU': Object.assign(
    {},
    ru,
    activity_ru,
    v3_ru,
    invoice_ru,
    creditCardVerification_ru_RU
  ),
  'de-DE': Object.assign(
    {},
    de,
    activity_de,
    v3_de,
    invoice_de,
    creditCardVerification_de_DE
  ),
  'it-IT': Object.assign(
    {},
    itIt,
    activity_itIt,
    v3_itIt,
    creditCardVerification_it_IT
  ),
  'pl-PL': Object.assign(
    {},
    pl,
    activity_pl,
    v3_pl,
    creditCardVerification_pl_PL
  ),
  'ar-SA': Object.assign(
    {},
    ar,
    activity_ar,
    v3_ar,
    creditCardVerification_ar_SA
  ),
  'id-ID': Object.assign(
    {},
    id,
    activity_id,
    v3_id,
    creditCardVerification_id_ID
  )
};

const LANG_TEXT = {
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'ja-JP': '日本語',
  'th-TH': 'ไทย',
  'ko-KR': '한국어',
  'de-DE': 'Deutsch',
  'en-US': 'English',
  'es-ES': 'Español',
  'fr-FR': 'Français',
  'pt-PT': 'Português',
  'ru-RU': 'Русский',
  'tr-TR': 'Türkçe',
  'vi-VN': 'Tiếng Việt',
  'it-IT': 'Italian',
  'pl-PL': 'Polski',
  'ar-SA': 'العربية',
  'id-ID': 'Bhs Indonesia'
};

const DEFAULT_LANG = 'en-US';
export const LANGUAGE_LOCALSTORGE_NAME = '37games_page_lang';

// 匹配浏览器语言到LANG_MAP
const getBrowserLanguage = function () {
  if (window.navigator) {
    let lang =
      window.navigator.language ||
      window.navigator.browserLanguage ||
      window.navigator.systemLanguage;
    // 从浏览器语言读到的阿拉伯语系统标识太多了，这里提前判断
    if (lang.indexOf('ar') > -1) {
      return 'ar-SA';
    }
    if (lang.indexOf('pt') > -1) {
      return 'pt-PT';
    }
    if (lang.indexOf('-') > -1) {
      let langArr = lang.split('-');
      let realLang = langArr[0].toLowerCase() + '-' + langArr[1].toUpperCase();
      return LANG_MAP[realLang] ? realLang : false;
    } else {
      let realLang = lang.toLowerCase();
      let res = '';
      /* eslint-disable no-unused-vars */
      for (let key in LANG_MAP) {
        let langkey = key.split('-')[0];
        if (realLang === langkey) {
          res = key;
          break;
        }
      }
      return res;
    }
  } else {
  }
};

const getLocalLang = function () {
  let localLang = globalConfig.getLclStorageItem(LANGUAGE_LOCALSTORGE_NAME);
  return localLang;
};

export default {
  language: '',
  defaultLang: DEFAULT_LANG,
  getLangMap() {
    return LANG_MAP;
  },
  setLangMap(newLangMap) {
    LANG_MAP = newLangMap;
  },
  setLanguage(language) {
    let finalLang = language;
    if (finalLang?.includes('pt')) {
      finalLang = 'pt-PT';
    }
    this.language = finalLang;
    this.updatePageDirection();
  },
  getLanguage() {
    return this.language;
  },
  init() {
    if (this.language) {
      return;
    }
    var lan =
      getHrefParam('appLanguage') ||
      getHrefParam('language') ||
      getLocalLang() ||
      getBrowserLanguage() ||
      DEFAULT_LANG;

    // 特殊处理：日本江山美人固定为日语ja-JP
    const gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('gameID') ||
      globalConfig.getHrefParam('game_id') ||
      '';
    if (gameId == 2) {
      lan = 'ja-JP';
    }
    if (lan?.includes('pt')) {
      lan = 'pt-PT';
    }
    this.setLanguage(lan);
  },
  mapMutiples(fields, lan) {
    if (lan) {
      this.setLanguage(lan);
    }

    var languages = {};
    /*
             数组的使用方式
            languages.mapMutiples([
            "feedback",
            "cancel",
            "confirm",
            "switch"]}

            feedback 是产对的对象的字段名， 语言包的字段名也是feedback。

            对象的使用方式：
             languages.mapMutiples({
                 "feedback" : "abc"
             })

             feedback 是产对的对象的字段名，abc 是语言包的字段名。
        */
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    if (fields instanceof Array) {
      /* eslint-disable no-unused-vars */
      for (let i = 0, len = fields.length; i < len; i++) {
        let key = fields[i];
        languages[key] = LAN[key] || LANG_MAP[DEFAULT_LANG][key];
        languages[key] =
          (languages[key] &&
            languages[key].toString().replace('{mainHost}', HOST)) ||
          '';
      }
    } else {
      /* eslint-disable no-unused-vars */

      for (let prop in fields) {
        let mapKey = fields[prop];
        languages[prop] = LAN[mapKey] || LANG_MAP[DEFAULT_LANG][mapKey];
        languages[prop] =
          (languages[prop] &&
            languages[prop].toString().replace('{mainHost}', HOST)) ||
          '';
      }
    }

    return languages;
  },

  switch(fields, lan) {
    this.setLanguage(lan);
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    var languages = {};
    for (let i = 0, len = fields.length; i < len; i++) {
      let key = fields[i];
      languages[key] = LAN[key] || LANG_MAP[DEFAULT_LANG][key];
      languages[key] =
        (languages[key] &&
          languages[key].toString().replace('{mainHost}', HOST)) ||
        '';
    }
    return languages;
  },
  get(fielName, lan) {
    if (lan) {
      this.setLanguage(lan);
    }
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    let result = LAN[fielName] || LANG_MAP[DEFAULT_LANG][fielName];
    return (result && result.toString().replace('{mainHost}', HOST)) || '';
  },
  getLangText() {
    return LANG_TEXT;
  },
  getAll() {
    const LAN = LANG_MAP[this.language] || LANG_MAP[DEFAULT_LANG];
    for (let key in LAN) {
      LAN[key] =
        (LAN[key] && LAN[key].toString().replace('{mainHost}', HOST)) || '';
    }
    return LAN;
  },
  isRtlDirection() {
    return RTL_LANG_LIST.includes(this.language);
  },
  updatePageDirection() {
    if (this.isRtlDirection()) {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
  },
  // 获取指定语言的文案
  getSpecifyLang(lang, key) {
    return LANG_MAP?.[lang]?.[key] || LANG_MAP?.[DEFAULT_LANG]?.[key] || '';
  }
};
